import { SHELL_TAB_NAV_ITEMS, type ShellNavItem } from '../shell-nav.types';

export type TabItem = ShellNavItem;

export const TAB_ITEMS: readonly TabItem[] = SHELL_TAB_NAV_ITEMS;
